
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.64 6.62l4.293 4.293a.924.924 0 101.308-1.308L3.526 6.891h8.8a.924.924 0 100-1.849h-8.8l2.715-2.714a.924.924 0 00-1.308-1.307L.641 5.313a.924.924 0 000 1.307z","fill":"#4B4B4B"}})])
          )
        }
      }
    